<template>

    <div>
        <div class="section">
            <div class="title">
                调查过程
            </div>
            <div class="item">
                <div class="label">
                    调查节点
                </div>
                <div class="value">
                    <el-input v-model="editDoubtCourse.dcTaskSubJect" placeholder="请输入" size="small"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    调查时间
                </div>
                <div class="value">
                    <el-date-picker
                    v-model="editDoubtCourse.tCourTm"
                    type="datetime"
                    size="small"
                    class="citem-input"
                    placeholder="选择日期时间">
                    </el-date-picker>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    调查省级市
                </div>
                <div class="value">
                    <el-cascader
                    size="small"
                    :options="options"
                    v-model="selectedOptions"
                    @change="handleRegionChange">
                    </el-cascader>
                    <!-- <el-input v-model="editDoubtCourse.cCourAddr" placeholder="请输入" size="small"></el-input> -->
                </div>
            </div>
            <div class="item">
                <div class="label">
                    调查地点
                </div>
                <div class="value">

                    <el-select v-model="editDoubtCourse.cCourPlace" size="small" placeholder="请选择" class="citem-input">
                        <el-option
                        v-for="item in cCourPlaceList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    调查项目
                </div>
                <div class="value">
                    <el-select v-model="editDoubtCourse.cCourPro" size="small" placeholder="请选择" class="citem-input">
                        <el-option
                        v-for="item in cCourProList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            
            <div class="item">
                <div class="label">
                    案件类型
                </div>
                <div class="value">
                    <el-select v-model="editDoubtCourse.cCourMode" size="small" placeholder="请选择" class="citem-input">
                        <el-option
                        v-for="item in CCourModeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    被调查人姓名
                </div>
                <div class="value">
                    <el-input v-model="editDoubtCourse.cCourOperNme" placeholder="请输入" size="small"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    被调查人与被保人关系
                </div>
                <div class="value">
                    <el-select v-model="editDoubtCourse.cCourRela" size="small" placeholder="请选择" class="citem-input">
                        <el-option
                        v-for="item in cCourRelaList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    调查过程
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="editDoubtCourse.cProcess" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>

        </div>

        <div class="section">
            <div class="title">
                调查资料
            </div>
            <div style="margin:0 10px;width:100%">
                <div class="handle" v-if="stepsActive">
                    <div>
                        <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="isAddCaseMaterial=true">添加资料文件夹</el-button>
                        <!-- <el-button type="primary" size="mini" @click="downFileAnXinDcTask">下载调查资料</el-button> -->
                    </div>
                </div>
                
                <div class="section-item" v-for="(mitem,mindex) in materialList" :key="mindex">
                    <div class="stitle">
                        {{mitem.key}}
                        <div v-if="stepsActive">
                            <el-button type="text" icon="el-icon-download" size="mini" @click="getAccidentImg(mitem.data,mitem.key)">生成pdf</el-button>
                            <el-button type="text" icon="el-icon-edit" size="mini" @click="editName(mindex)"  v-if="stepsActive">编辑资料文件夹名称</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteDoubTaskMaterialByDoubtCourseIdTip(mitem.key)"  v-if="stepsActive">删除资料文件夹</el-button>
                            <el-checkbox  v-model="mitem.isEditMaterialSort" style="margin-left:10px" @change="changeIsEditMaterialSort(mindex)" v-if="stepsActive">拖拽图片</el-checkbox >
                        </div>
                    </div>
                    <div class="materiallist">
                        <draggable v-model="materialList[mindex].data"  chosenClass="chosen" forceFallback="true" group="people" animation="500" :disabled="!mitem.isEditMaterialSort" @end="draggableOnEnd(mindex)">
                            <transition-group>
                                <div class="material" v-for="(item,index) in materialList[mindex].data" :key="index">
                                    <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                    <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                    <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                    <el-image
                                    style="width: 120px; height: 120px"
                                    :src="item.path+'?x-oss-process=image/resize,w_200'"
                                    v-else
                                    @click="showImg(item.path,mitem.data)"
                                    fit="cover"></el-image>
                                    <img src="../../../assets/images/icon08.png" class="close" @click="deleteDoubTaskMaterialTip(item.id)" alt=""  v-if="stepsActive">
                                    <div class="filename">{{item.fileName}}</div>
                                </div>
                            </transition-group>
                        </draggable>
                        <div  v-if="stepsActive">
                            <el-upload
                                :action="uploadUrl"
                                multiple
                                :show-file-list="false"
                                :http-request="addMaterial"
                                >
                                <el-button type="primary" icon="el-icon-circle-plus-outline" @click="materialIndex = mindex">新增</el-button>
                            </el-upload>
                        </div>
                    </div>
                </div>

                
            </div>
        </div>
        
        <div class="btns" v-if="stepsActive">
            <el-button type="primary" icon="el-icon-edit" @click="doubtCourseUpdate()">确认编辑</el-button>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddCaseMaterial" title="添加资料" width="800px">
            <div class="item">
                <div class="label">
                    资料名称
                </div>
                <div class="value">
                    <el-input v-model="addCaseMaterial.name" size="small" placeholder="请输入" style="width:300px"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    单证资料
                </div>
                <div class="value" style="width:300px">
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :show-file-list="false"
                        :http-request="uploadCPath"
                        >
                        <el-button icon="el-icon-upload2" type="primary" size="small" :loading="finishNum!=allNum?true:false">上传资料</el-button>
                    </el-upload>
                    <span style="margin-left:10px">
                        完成度：{{finishNum}} / {{allNum}} {{finishNum!=allNum?'请稍等':''}}
                    </span>
                </div>
            </div>
            <div class="materiallist">
                <div class="material" v-for="(item,index) in addCaseMaterialList" :key="index">
                    <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                    <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                    <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                    <el-image
                    style="width: 120px; height: 120px"
                    :src="item.path"
                    v-else
                    @click="download(item.path,item.name)"
                    :fit="cover"></el-image>
                    <div class="filename">{{item.fileName}}</div>
                </div>
            </div>
            <div class="btns">
                <el-button type="primary" icon="el-icon-edit" @click="addDoubTaskMaterialRange">确认</el-button>
            </div>
        </el-dialog>



        <el-dialog :close-on-click-modal="false" :visible.sync="isEditName" title="编辑资料名称" width="800px">
           
            <div class="item">
                <div class="label">
                    资料名称
                </div>
                <div class="value">
                    <el-input v-model="materialListName" size="small" placeholder="请输入" style="width:300px"></el-input>
                </div>
            </div>
            
           
            <div class="btns">
                <el-button type="primary" icon="el-icon-edit" @click="editMaterialName">确认</el-button>
            </div>
        </el-dialog>


        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
    
            
</template>
<script>
import api from '../../../api/main'
import { batchDownloadList} from "../../../utils/downZip";
import { regionData , CodeToText , TextToCode } from "element-china-area-data";
import { cCourPlaceList , cCourProList , cCourRelaList , CCourModeList, } from "../../../assets/selectList/anxin";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import draggable from 'vuedraggable'
import { parseTimeS } from "../../../utils/index"
export default {
    components:{
        ElImageViewer,
        draggable
    },
    data(){
        return {
            options:regionData,
            cCourPlaceList:cCourPlaceList,
            cCourProList:cCourProList,
            cCourRelaList:cCourRelaList,
            CCourModeList:CCourModeList,
            editDoubtCourse:{
                tCourTm:'',
            },
            selectedOptions:[],
            materialList:[],

            addCaseMaterial:{},

            addCaseMaterialList:[],
            isAddCaseMaterial:false,

            stepsActive:false,

            allNum:0,
            finishNum:0,
            materialListName:'',
            isEditName:false,


            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            
            uploadUrl:'',
            oldName:'',
        }
    },
    created(){
        this.stepsActive = this.$route.query.stepsActive == 'true' ? true : false;
        this.doubtCourseQueryByDoubtCourseId(this.$route.query.id);
        this.doubtCourseQueryMaterByDoubtCourseId(this.$route.query.id);
    },
    methods:{
        
        async doubtCourseQueryByDoubtCourseId(id){
            let res = await api.doubtCourseQueryByDoubtCourseId(id);
            this.editDoubtCourse = res.data.data;
            console.log(this.editDoubtCourse)
            this.selectedOptions = [];
            for(let index in this.editDoubtCourse.cCourAll){
                this.selectedOptions.push(this.editDoubtCourse.cCourAll[index]+'');
            }
            
            console.log(this.selectedOptions);
            this.$forceUpdate();
        },
        async doubtCourseQueryMaterByDoubtCourseId(id){
            let res = await api.doubtCourseQueryMaterByDoubtCourseId(id);
            this.materialList = res.data.data;
        },
        handleRegionChange(){
            let e = this.selectedOptions;
            if(e[2]){
                this.editDoubtCourse.cCourAddr = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]+'-'+CodeToText[e[0],e[1],e[2]]
            }else if(e[1]){
                this.editDoubtCourse.cCourAddr = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]
            }
            this.editDoubtCourse.cCourAll=this.selectedOptions;
            for(let index in this.selectedOptions){
                this.editDoubtCourse.cCourAll[index] = parseInt(this.selectedOptions[index]);
            }
        },


        // 上传
        async uploadCPath(file){
            if(!this.addCaseMaterial.name){
                this.$message({
                    type: 'warning',
                    message: '请先填写资料名称!'
                });
                return;
            }
            let name = this.addCaseMaterial.name;
            let fileTypeList = file.file.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.replace(/\s*/g,"");
            fileType = fileType.toLowerCase( );

            if(fileType=='jpg'||fileType=='png'||fileType=='gif'||fileType=='jpep'||fileType=='xlsx'||fileType=='doc'||fileType=='docx'||fileType=='ppt'||fileType=='pptx'){
                if(file.file.size>(1024*1024*10)){
                    this.$message({
                        type: 'error',
                        message: '图片和文档不能超过10MB!'
                        // message: '图片和文档只能上传jpg，png，gif，jpep，xlsx，doc，docx，ppt，pptx，pdf，zip，rar；且不能超过10MB!'
                    });
                    return;
                }
            }else if(fileType=='pdf'||fileType=='zip'||fileType=='rar'){
                if(file.file.size>(1024*1024*500)){
                    this.$message({
                        type: 'error',
                        message: '文件不能超过500MB'
                    });
                    return;
                }
            }else if(fileType=='rmvb'||fileType=='rm'||fileType=='ts'||fileType=='tp'||fileType=='avi'||fileType=='3gp'||fileType=='mp4'||fileType=='mkv'){
                if(file.file.size>(1024*1024*500)){
                    this.$message({
                        type: 'error',
                        message: '视频不能超过500MB'
                    });
                    return;
                }
            }else if(fileType=='mp3'||fileType=='aac'||fileType=='wav'||fileType=='wma'||fileType=='flac'||fileType=='ape'){
                if(file.file.size>(1024*1024*100)){
                    this.$message({
                        type: 'error',
                        message: '音频不能超过100MB'
                    });
                    return;
                }
            }else{
                this.$message({
                    type: 'error',
                    message: '不支持上传格式'
                });
                return;
            }
            this.allNum = this.allNum+1;
            let res = await api.uploadOther(file.file);
            this.addCaseMaterialList.push({
                fileType:fileType,
                fileName:file.file.name,
                name:name,
                path:res,
                doubtCourseId:this.$route.query.id,
                anXinDcTaskId:this.$route.query.anXinDcTaskId,
            });
            this.finishNum = this.finishNum+1;
            this.$forceUpdate();

        },
        // 添加资料
        // addCaseMaterialF(){
        //     console.log(this.addCaseMaterial);
        //     this.materialList.push(this.addCaseMaterialList)
        //     this.addCaseMaterialList = [];
        //     this.isAddCaseMaterial = false;
        //     this.allNum=0,
        //     this.finishNum=0;
        //     this.$forceUpdate();
        // },
        // 编辑资料名称
        editName(index){
            this.materialListIndex = index;
            this.materialListName = this.materialList[index].key;
            this.oldName = this.materialList[index].key;
            this.isEditName = true;
        },
        // 调查资料下载
        async downFileAnXinDcTask(){
            let res = await api.downFileAnXinDcTask(this.$route.query.anXinDcTaskId,{
                zipName:'调查资料'
            });
        },
        // 新增单个资料
        async addMaterial(file){
            let name = this.materialList[this.materialIndex].key;
            let fileTypeList = file.file.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.replace(/\s*/g,"");
            fileType = fileType.toLowerCase( );
            console.log(file);
            if(fileType=='jpg'||fileType=='png'||fileType=='gif'||fileType=='jpep'||fileType=='xlsx'||fileType=='doc'||fileType=='docx'||fileType=='ppt'||fileType=='pptx'){
                if(file.file.size>(1024*1024*10)){
                    this.$message({
                        type: 'error',
                        message: '图片和文档不能超过10MB!'
                    });
                    return;
                }
            }else if(fileType=='pdf'||fileType=='zip'||fileType=='rar'){
                if(file.file.size>(1024*1024*500)){
                    this.$message({
                        type: 'error',
                        message: '文件不能超过500MB'
                    });
                    return;
                }
            }else if(fileType=='rmvb'||fileType=='rm'||fileType=='ts'||fileType=='tp'||fileType=='avi'||fileType=='3gp'||fileType=='mp4'||fileType=='mkv'){
                if(file.file.size>(1024*1024*500)){
                    this.$message({
                        type: 'error',
                        message: '视频不能超过500MB'
                    });
                    return;
                }
            }else if(fileType=='mp3'||fileType=='aac'||fileType=='wav'||fileType=='wma'||fileType=='flac'||fileType=='ape'){
                if(file.file.size>(1024*1024*100)){
                    this.$message({
                        type: 'error',
                        message: '音频不能超过100MB'
                    });
                    return;
                }
            }else{
                this.$message({
                    type: 'error',
                    message: '不支持上传格式'
                });
                return;
            }

            let res = await api.uploadOther(file.file);
            console.log(res);
            this.addCaseMaterialList = [{
                fileType:fileType,
                fileName:file.file.name,
                name:name,
                path:res,
                doubtCourseId:this.$route.query.id,
                anXinDcTaskId:this.$route.query.anXinDcTaskId,
            }]
            this.addDoubTaskMaterialRange();
            this.$forceUpdate();
        },
        // 添加调查节点的资料
        async addDoubTaskMaterialRange(){
            let res = await api.addDoubTaskMaterialRange(this.addCaseMaterialList);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '添加成功'
                });
                this.addCaseMaterialList = [];
                this.isAddCaseMaterial = false;
                this.allNum=0,
                this.finishNum=0;
                this.addCaseMaterial.name = '';
                this.doubtCourseQueryMaterByDoubtCourseId(this.$route.query.id);
            }
        },

        // 删除资料
        async deleteDoubTaskMaterialTip(id){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteDoubTaskMaterial(id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteDoubTaskMaterial(id){
            let res = await api.deleteDoubTaskMaterial(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.doubtCourseQueryMaterByDoubtCourseId(this.$route.query.id);
            }
        },

        // 图片生成pdf
        async getAccidentImg(list,name){
            let ImgList = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    ImgList.push(list[i].path);
                }
            }
            let res = await api.imgToPdf({
                imgUrl:ImgList,
                anXinDcTaskId:this.$route.query.anXinDcTaskId,
                doubtCourseId: this.$route.query.id,
                name:name,
                fileName:this.editDoubtCourse.dcTaskSubJect+"-"+name+'.pdf',
            });
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '生成成功!'
                });
                this.doubtCourseQueryMaterByDoubtCourseId(this.$route.query.id);
            }
            
        },
        // 编辑调查过程
        async doubtCourseUpdate(){
            this.editDoubtCourse.tCourTm = parseTimeS(this.editDoubtCourse.tCourTm)
            let res = await api.doubtCourseUpdate(this.editDoubtCourse);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
            }
        },
        // 编辑资料名称
        async editMaterialName(){
            let res = await api.updateMaterialNameByDoubtCourseId({
                doubtCourseId: this.$route.query.id,
                name: this.materialListName,
                oldName:this.oldName
            });
            if(res.data.code == '200'){
                this.isEditName = false;
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
                this.doubtCourseQueryMaterByDoubtCourseId(this.$route.query.id);
            }
        },

        // 删除一整个资料
        deleteDoubTaskMaterialByDoubtCourseIdTip(name){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteDoubTaskMaterialByDoubtCourseId_name(name);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteDoubTaskMaterialByDoubtCourseId_name(name){
            let res = await api.deleteDoubTaskMaterialByDoubtCourseId_name({
                doubtCourseId:this.$route.query.id,
                name:name,
            });
            if(res.data.code == '200'){
                this.isEditName = false;
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
                this.doubtCourseQueryMaterByDoubtCourseId(this.$route.query.id);
            }
        },

        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        // 查看资料
        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            console.log(this.imgIndex);
            console.log(imglist);
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        // 下载资料
        download(path,name){
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },

        // 拖拽接受
        async draggableOnEnd(index){
            for(let i in this.materialList[index].data){
                this.materialList[index].data[i].sort = parseInt(i);
            }
            let res = await api.SortDoubTaskMaterial(this.materialList[index].data);

        },
    },
}
</script>
<style lang="scss" scoped>
    .section{
        margin: 10px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 15px;
        padding-bottom: 10px;
        .title{
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            background-color: #DEDEDE;
            padding:8px 15px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 120px;
            }
            .value{
                width: 220px;
                display: flex;
                align-items: center;
            }
            .piclist{
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding:10px 15px;
                .label{
                    width: 230px;
                    font-size: 14px;
                }
                .pics{
                    display: flex;
                    flex-wrap: wrap;
                    .pics-item{
                        width: 100px;
                        height: 100px;
                        position: relative;
                        margin: 15px;
                        .img{
                            width: 100px;
                            height: 100px;
                        }
                        .close{
                            position: absolute;
                            top: -12px;
                            right: -12px;
                            width: 24px;
                            height: 24px;
                        }
                        
                    }
                }
                .uploadbtn{
                    border: 1px solid #dcdcdc;
                    width: 106px;
                    height: 106px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 15px;
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
                
            }
        }
    
    }
    .item{
        font-size: 14px;
        padding:10px 15px;
        display: flex;
        align-items: center;
        .label{
            margin-bottom: 5px;
            width: 120px;
        }
        .value{
            width: 220px;
            display: flex;
            align-items: center;
            .value-textarea{
                border:1px solid #DCDFE6;
                width: 564px;
                min-height: 50px;
                border-radius: 4px;
                padding: 5px 14px;
                font-size: 13px;
                line-height: 24px;
            }
        }
        .piclist{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:10px 15px;
            .label{
                width: 230px;
                font-size: 14px;
            }
            .pics{
                display: flex;
                flex-wrap: wrap;
                .pics-item{
                    width: 100px;
                    height: 100px;
                    position: relative;
                    margin: 15px;
                    .img{
                        width: 100px;
                        height: 100px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .uploadbtn{
                border: 1px solid #dcdcdc;
                width: 106px;
                height: 106px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px;
                img{
                    width: 106px;
                    height: 106px;
                }
            }
            
        }
    }
    .section-item{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 10px;
        margin-top: 10px;
        .stitle{
            background-color: #f1f1f1;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            border-bottom:1px solid #DEDEDE;
            padding:8px 15px;
            display: flex;
            justify-content: space-between;
        }
        
    }
    .materiallist{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 15px;
        .material{
            border: 1px dashed #dcdcdc;
            width: 150px;
            height: 170px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            margin:10px;
            position: relative;
            float: left;
            img{
                width: 120px;
            }
            .close{
                width: 25px;
                height: 25px;
                position: absolute;
                right: 3px;
                top: 3px;
            }
            .filename{
                width: 130px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                margin-top: 2px;
            }
        }
    }
    .btns{
        display: flex;
        justify-content: center;
    }
</style>
